<template>
    <div v-if="isReady && false" class="seriesSurvey" @mouseover="hover = true" @mouseleave="hover = false">
        <img class="premium" src="@/assets/Shared/premium.png">
        <div v-if="!hover || isPremium" class="my-content">
            <h1 class="title">{{ poolData.question }}</h1>
            <h5 class="description">{{ $t("account.survey_expire_date") }} {{ remainingTime.days }} {{
                $t("account.survey_expire_day") }} {{ remainingTime.hours
                }} {{ $t("account.survey_expire_hours") }} </h5>
            <!-- <h5 class="description">Son Eklenen Dizi: The Mandalorian</h5> -->

            <div id="filmSecme" class="pool">
                <div v-for="element in poolData.answers" class="film">
                    <input type="radio" name="filmSecme" :value="element.id" class="d-none" :id="element.id"
                        v-model="picked">
                    <label :for="element.id" class="inner-film">
                        <label :for="element.id"></label>
                        <img :src="getImgUrl(element.choice)" :alt="element.choice">
                        <span>{{ element.count }} {{ $t("account.survey_votes") }}</span>
                    </label>
                </div>
            </div>
            <span class="description"
                v-if="remainingTime.days == 0 && remainingTime.hours == 0 && remainingTime.minutes == 0">
                {{ $t("account.survey_message") }}
            </span>
            <button v-else @click="vote()" class="medium-purple-button">{{ $t("account.survey_send") }}</button>
        </div>
        <ProWall v-if="hover && !isPremium">
        </ProWall>
    </div>
</template>

<script>
import axios from 'axios'
import ProWall from '../Premium/ProWall.vue'
export default {
    components: {
        ProWall
    },

    data() {
        return {
            poolData: {},
            isReady: false,
            hover: false,
            picked: ""
        };
    },
    created() {
        this.getPool()

    },
    beforeMount() {

    },
    methods: {
        vote() {
            if (this.picked != "" && !this.poolData.isCurrentUserAnswered) {
                axios.get('/api/Poll/VotePoll', { params: { choiceId: this.picked } }).then((response) => {

                }).finally(() => {
                    this.getPool()
                    this.picked = ""
                    alert(this.$t("account.survey_vote_success"))
                }).catch(error => {
                    console.log(error.response.data)
                })
            } else if (this.picked != "" && this.poolData.isCurrentUserAnswered) {
                axios.get('/api/Poll/VotePoll', { params: { choiceId: this.picked } }).then((response) => {

                }).finally(() => {
                    this.getPool()
                    this.picked = ""
                    alert(this.$t("account.survey_vote_change"))
                }).catch(error => {
                    console.log(error.response.data)
                })
            } else if (this.picked == "") {
                alert(this.$t("account.survey_vote_error"))
            }

        },
        getPool() {
            axios.get('/api/Poll/GetPoll', { params: { id: 25 } }).then((response) => {
                this.poolData = JSON.parse(JSON.stringify(response.data))
                this.picked = this.poolData.userSelectedChoiceId

            }).then(() => {
                this.isReady = true
            }).catch(error => {
                console.log(error.response.data)
            })
        },
        getImgUrl(pic) {
            let new_url = pic.toLowerCase().replaceAll(" ", "-")
            return require('@/assets/account/pool/' + new_url + '.jpg')
        }

    },
    mounted() {

    },
    watch: {

    },
    computed: {
        remainingTime() {
            var t = Date.parse(this.poolData.deadline) - Date.parse(new Date());
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            var days = Math.floor(t / (1000 * 60 * 60 * 24));
            return {
                'total': t,
                'days': days,
                'hours': hours,
                'minutes': minutes,
                'seconds': seconds
            };
        },
        isPremium() {
            return this.$store.getters.getUserData.isPremium
        }

    }
}
</script>

<style scoped>
.d-none {
    display: none;
}

.d-flex {
    display: flex;
}

.seriesSurvey {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-self: center;
    align-self: center;
    width: 100%;
    border-radius: 16px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 24px 48px 24px 48px;
}

.premium {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 8%;
    z-index: 2
}

.my-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.my-content .medium-purple-button {
    align-self: flex-end;
    margin-top: 10px;
}

.my-content .title {
    color: var(--Black-Gray, #696969);
    /* WEB/Title Medium */
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.my-content .description {
    color: var(--Primary, #8887C6);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.my-content .pool {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
}

.my-content .pool .film {
    display: flex;
    flex-direction: column;
    width: 23%;
    border-radius: 8px;
}

.my-content .pool .film .inner-film {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    border-radius: 8px;
    padding: 16px 0px;
    box-shadow: 0px 4px 4px 0px #D9D9D9;
}

#filmSecme .film label {
    background-color: #f4f4f4;
}

#filmSecme .film label span {
    font-weight: 700;
}

#filmSecme .film label label {
    width: 20px;
    height: 20px;
    border: 1px solid #828282;
    border-radius: 50%;
}

#filmSecme .film label img {
    height: 150px;
    padding: 0px 40px;
    border-radius: 4px;
}

#filmSecme .film input[type="radio"]:checked+label {
    background: #9CD189;
}

#filmSecme .film input[type="radio"]:checked+label label {
    border: 0;
    background: #cef0c0;
}



@media (max-width: 660px) {
    .my-content .pool .film {
        width: 48%;
        margin-top: 20px;
    }

    .my-content {
        gap: 0px;
    }

    .my-content .medium-purple-button {
        margin-top: 24px;
    }
}
</style>